import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TestState {
  paymentMethods: string[];
  banks: string[];
  providers: any[];
  merchants: any[];
  selectedProvider: string | null;
  selectedMerchant: string | null;
}

const initialState: TestState = {
  paymentMethods: ["card", "sbp", "account-transfer", "any-bank"],
  banks: ["sberbank", "tinkoff", "raiffeisen", "alfabank", "vtb"],
  providers: [],
  merchants: [],
  selectedProvider: null,
  selectedMerchant: null,
};

const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    setProviders: (state, action: PayloadAction<any[]>) => {
      state.providers = action.payload;
    },
    setMerchants: (state, action: PayloadAction<any[]>) => {
      state.merchants = action.payload;
    },
    setSelectedProvider: (state, action: PayloadAction<string | null>) => {
      state.selectedProvider = action.payload;
    },
    setSelectedMerchant: (state, action: PayloadAction<string | null>) => {
      state.selectedMerchant = action.payload;
    },
  },
});

export const {
  setProviders,
  setMerchants,
  setSelectedProvider,
  setSelectedMerchant,
} = testSlice.actions;

export default testSlice.reducer;
